import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Table } from "reactstrap";
import React, { Component } from 'react';
import { apiFetch, API } from "../../services/api";

// Modal affichant le ROI d'un évènement physique : inscrits/présents, coût
// hors Ads, dépense Ads (ensembles rattachés), coût total, coût par
// inscrit/présent, visites (Athena), transactions attribuées, revenus/commission
// et ROI vs coût total.
export default class PhysicalEventRoiModal extends Component {
    state = { roi: null, loading: true, error: null };

    componentDidMount() {
        const slug = this.props.selectedEvent?.slug;
        apiFetch(API.back + '/physical-event-roi?slug=' + encodeURIComponent(slug), { method: 'GET' })
            .then((res) => {
                if (!res.ok) {
                    this.setState({ loading: false, error: "Erreur lors du chargement du ROI (" + res.status + ")" });
                    return null;
                }
                return res.json();
            })
            .then((roi) => {
                if (roi === null) {
                    return;
                }
                this.setState({ roi, loading: false });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, error: "Erreur lors du chargement du ROI" });
            });
    }

    fmtEur = (v) => (Number(v) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

    render() {
        const { roi, loading, error } = this.state;
        const roiPct = roi && roi.roi !== undefined ? (roi.roi * 100).toFixed(0) + " %" : "—";

        return (
            <Modal show={this.props.isOpen} onHide={this.props.closeModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>ROI — {this.props.selectedEvent?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <p>Chargement…</p> : null}
                    {error ? <p style={{ color: "#c0392b" }}>{error}</p> : null}
                    {roi ? (
                        <Table responsive>
                            <tbody>
                            <tr><td>Inscrits</td><td><b>{roi.countOfRegistered}</b></td></tr>
                            <tr><td>Présents</td><td>{roi.countOfPresent}</td></tr>
                            <tr><td>No-show</td><td>{typeof roi.noShowRate === "number" ? (roi.noShowRate * 100).toFixed(0) + " %" : "—"}</td></tr>
                            <tr><td>Coût hors Ads</td><td>{this.fmtEur(roi.cost)}</td></tr>
                            <tr><td>Dépense Ads (ensembles rattachés)</td><td>{this.fmtEur(roi.adSpend)}</td></tr>
                            <tr><td>Coût total</td><td><b>{this.fmtEur(roi.totalCost)}</b></td></tr>
                            <tr><td>Coût par inscrit</td><td><b>{roi.countOfRegistered > 0 ? this.fmtEur(roi.costPerRegistration) : "—"}</b></td></tr>
                            <tr><td>Coût par présent</td><td>{roi.countOfPresent > 0 ? this.fmtEur(roi.costPerPresent) : "—"}</td></tr>
                            <tr><td>Visites générées</td><td>{roi.totalVisits}</td></tr>
                            <tr><td>Transactions attribuées</td><td>{roi.countOfTransactions}</td></tr>
                            <tr><td>Chiffre d'affaires généré</td><td>{this.fmtEur(roi.totalRevenue)}</td></tr>
                            <tr><td>Commission générée</td><td><b>{this.fmtEur(roi.totalCommission)}</b></td></tr>
                            <tr><td>ROI (commission vs coût total)</td><td><b>{roiPct}</b></td></tr>
                            </tbody>
                        </Table>
                    ) : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.closeModal}>Fermer</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
